import {announce} from '@github-ui/aria-live'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import {LABELS} from '../constants'
import {useSavedViewEndpoints} from '../contexts/SavedViewEndpointsContext'
import type {DeleteSavedViewVariables} from '../types'
import {
  removeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutation,
} from '../utils/saved-view-mutations'

// Drops the single-view cache for the deleted id, then invalidates the list.
export function useDeleteSavedViewMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()
  const {basePath, listUrl} = useSavedViewEndpoints(owner, repo)

  return useMutation<void, Error, DeleteSavedViewVariables>({
    mutationFn: async ({id}) => {
      await sendSavedViewMutation(
        `${basePath}/${encodeURIComponent(id)}.json`,
        {method: 'DELETE'},
        LABELS.views.deleteError,
      )
    },
    onSuccess: (_data, {id}) => removeSavedViewCaches({queryClient, owner, repo, basePath, listUrl}, id),
    onError: () => announce(LABELS.views.deleteError, {assertive: true}),
  })
}
